import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * ISO standar: https://es.wikipedia.org/wiki/ISO_3166-1
 */
// Constants
import countries from "./countries";
var isoCodes = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, countries.AT, 'at'), countries.EN, 'uk'), countries.ES, 'es'), countries.DE, 'de'), countries.NL, 'nl');
export default isoCodes;